/* tanaras-curls-lp.js */
(function () {
  'use strict';

  /* ── STATE ── */
  var S = { curl: null, len: null, ht: null, sj: null };

  /* ── PRICE TABLES (base × 1.2 = curls price) ── */
  /* SET Verdichtung: [U1, U2, GS, BA] × [35, 45, 55] */
  var P_SET  = [[175,220,300],[180,235,315],[190,245,330],[195,250,335]];
  var P_JUST = [[125,170,250],[130,185,270],[140,195,280],[145,200,285]];

  /* We show "ab X€" using U1 (cheapest group) for the selected length */
  var LI = { '35': 0, '45': 1, '55': 2 };

  function basePrice(pkg, lenStr) {
    var li  = LI[lenStr] || 0;
    var tbl = pkg === 'set' ? P_SET : P_JUST;
    return tbl[0][li]; /* U1 = lowest */
  }

  function curlsPrice(pkg, lenStr) {
    return Math.round(basePrice(pkg, lenStr) * 1.25);
  }

  /* ── SCROLL ── */
  function scrollTo(id) {
    var el = document.getElementById(id);
    if (!el) return;
    setTimeout(function () {
      var header = document.querySelector('.header-wrapper, .site-header, header');
      var offset = header ? header.offsetHeight + 16 : 80;
      var top = el.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }, 150);
  }

  window.tclpScrollToStart = function () {
    scrollTo('tclp-s1');
  };

  /* ── STEP 1: CURL TYPE ── */
  window.tclpPickCurl = function (val, el) {
    S.curl = val;
    document.querySelectorAll('.tclp-curl-c').forEach(function (c) {
      c.classList.remove('sel');
    });
    el.classList.add('sel');

    /* hide hint */
    var hint = document.getElementById('tclp-hint');
    if (hint) hint.classList.add('hidden');

    /* reveal step 2 */
    var s2 = document.getElementById('tclp-s2');
    if (s2 && !s2.classList.contains('vis')) {
      s2.classList.add('vis');
      scrollTo('tclp-s2');
    }
  };

  /* ── STEP 2: LÄNGE ── */
  window.tclpPickLen = function (len, el) {
    S.len = String(len);
    document.querySelectorAll('.tclp-len-c').forEach(function (c) {
      c.classList.remove('sel');
    });
    el.classList.add('sel');

    /* update SET/JUST prices if already shown */
    tclpUpdatePrices();

    /* reveal step 3 */
    var s3 = document.getElementById('tclp-s3');
    if (s3 && !s3.classList.contains('vis')) {
      s3.classList.add('vis');
      scrollTo('tclp-s3');
    }
  };

  /* ── STEP 3: HAARTYP ── */
  window.tclpPickHt = function (val, el) {
    S.ht = val;
    document.querySelectorAll('.tclp-ht-c').forEach(function (c) {
      c.classList.remove('sel');
    });
    el.classList.add('sel');

    /* reveal step 4 */
    var s4 = document.getElementById('tclp-s4');
    if (s4 && !s4.classList.contains('vis')) {
      s4.classList.add('vis');
      scrollTo('tclp-s4');
    }
  };

  /* ── STEP 4: SET vs JUST ── */
  window.tclpPickSj = function (val, el) {
    S.sj = val;
    document.querySelectorAll('.tclp-sj-c').forEach(function (c) {
      c.classList.remove('sel');
    });
    el.classList.add('sel');

    tclpUpdatePrices();
    tclpShowResult();
  };

  /* ── PRICE DISPLAY ── */
  function tclpUpdatePrices() {
    if (!S.len) return;
    var setEl  = document.getElementById('tclp-sj-set-price');
    var justEl = document.getElementById('tclp-sj-just-price');
    if (setEl)  setEl.textContent  = 'ab ' + curlsPrice('set',  S.len) + ' €';
    if (justEl) justEl.textContent = 'ab ' + curlsPrice('just', S.len) + ' €';
  }

  /* ── RESULT ── */
  function tclpShowResult() {
    if (!S.curl || !S.len || !S.ht || !S.sj) return;

    var price = curlsPrice(S.sj, S.len);
    var htLabel = S.ht === 'invisis' ? 'INVISIS' : 'THINVISIS';
    var sjLabel = S.sj === 'set'
      ? 'SET (Haare + Tools)'
      : 'JUST (nur Haare)';

    /* prod name */
    var prod = htLabel + ' Curls ' + S.curl;

    /* sub */
    var sub = S.len + ' cm · ' + sjLabel;

    /* pills */
    var pills = [S.curl, S.len + ' cm', htLabel, S.sj.toUpperCase()];

    /* WA message */
    var msg = encodeURIComponent(
      'Hallo! Ich möchte bestellen:\n' +
      prod + ', ' + S.len + 'cm, ' + S.sj.toUpperCase() +
      ' – ab ' + price + '€\n' +
      'Farbe besprechen wir gerne.'
    );

    /* fill result card */
    var el_prod  = document.getElementById('tclp-res-prod');
    var el_sub   = document.getElementById('tclp-res-sub');
    var el_price = document.getElementById('tclp-res-price');
    var el_pills = document.getElementById('tclp-res-pills');
    var el_cta   = document.getElementById('tclp-res-cta');

    if (el_prod)  el_prod.textContent  = prod;
    if (el_sub)   el_sub.textContent   = sub;
    if (el_price) el_price.textContent = 'ab ' + price + ' €';
    if (el_pills) el_pills.innerHTML   = pills.map(function (p) {
      return '<span class="tclp-res-pill">' + p + '</span>';
    }).join('');
    if (el_cta) {
      el_cta.setAttribute('href', 'https://wa.me/4915252843474?text=' + msg);
    }

    /* show result + bottom */
    var res = document.getElementById('tclp-result');
    var bot = document.getElementById('tclp-bottom');
    if (res && !res.classList.contains('vis')) {
      res.classList.add('vis');
      scrollTo('tclp-result');
    }
    if (bot) bot.classList.add('vis');
  }

  /* ── FAQ ── */
  window.tclpToggleFaq = function (el) {
    var isOpen = el.classList.contains('open');
    document.querySelectorAll('.tclp-fi').forEach(function (fi) {
      fi.classList.remove('open');
    });
    if (!isOpen) el.classList.add('open');
  };

})();
